import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const publisherList = (params = '') => Http.get(`/admin/publishers${serialize(params)}`)
export const publisherCreate = (params = '') => Http.post('/admin/publishers', params)
export const publisherByID = (params = '') => Http.get(`/admin/publishers/${params}`)
export const publisherUpdate = (params = '') => Http.put(`/admin/publishers/${params.id}`, params)
export const publisherDestroy = (params = '') => Http.delete(`/admin/publishers/${params.id}`)
